import { CHANGE_ODDS_PERIOD } from "./actionTypes";

export type OddsPeriod = "full" | "half1";

const DEFAULT_ODDS_PERIOD: OddsPeriod = "full";

const OddsPeriodReducer = (state: OddsPeriod = DEFAULT_ODDS_PERIOD, action: any) => {
  switch (action.type) {
    case CHANGE_ODDS_PERIOD:
      return action.payload;
    default:
      return state;
  }
};

export default OddsPeriodReducer;
